module.exports = __webpack_public_path__ + "static/img/key.2598518.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/key.png
// module id = iSl2
// module chunks = 0